export const AWC_ENV_LIST = {
  STG: {
    name: 'STG',
    domain: 'https://sstint.22onlinegames.com',
    reportDomain: 'https://sstint.22onlinegames.com',
  },
  UAT: {
    name: 'UAT',
    domain: 'https://tttint.apihub55.com',
    reportDomain: 'https://tttint.apihub55.com',
  },
  UAT_AWS05: {
    name: 'UAT',
    domain: 'https://tttap.sanatestlab.com',
    reportDomain: 'https://tttap.sanatestlab.com',
  },
  UAT_AWS12: {
    name: 'UAT',
    domain: 'https://tttap.in2testlab.com',
    reportDomain: 'https://tttap.in2testlab.com',
  },
  AWC: {
    name: 'AWCS01',
    domain: 'https://api.22onlinegames.com',
    reportDomain: 'https://fetch.22onlinegames.com',
  },
  AWCA: {
    name: 'AWCS02',
    domain: 'https://wcaap.ac2boag.com',
    reportDomain: 'https://wcafe.ac2boag.com',
  },
  AWS01: {
    name: 'AWCS01',
    domain: 'https://api.22onlinegames.com',
    reportDomain: 'https://fetch.22onlinegames.com',
  },
  AWS02: {
    name: 'AWCS02',
    domain: 'https://wcaap.ac2boag.com',
    reportDomain: 'https://wcafe.ac2boag.com',
  },
  AWS03: {
    name: 'AWCS03',
    domain: 'https://gciap.usplaynet.com',
    reportDomain: 'https://gcife.usplaynet.com',
  },
  AWS05: {
    name: 'AWCS05',
    domain: 'https://rwbap.rwbinter.cc',
    reportDomain: 'https://rwbfe.rwbinter.cc',
  },
  AWS06: {
    name: 'AWCS06',
    domain: 'https://fsaap.velkigames365.cc',
    reportDomain: 'https://fsafe.velkigames365.cc',
  },
  AWS07: {
    name: 'AWCS07',
    domain: 'https://idnap.idnkplay.com',
    reportDomain: 'https://idnfe.idnkplay.com',
  },
  AWS08: {
    name: 'AWCS08',
    domain: 'https://ufcap.ufagames99.live',
    reportDomain: 'https://ufcfe.ufagames99.live',
  },
  AWS09: {
    name: 'Private Net',
    domain: 'https://awsap.ambbest.live',
    reportDomain: 'https://awsfe.ambbest.live',
  },
  AWS10: {
    name: 'AWCS10',
    domain: 'https://cp1ap.cc1ps.com',
    reportDomain: 'https://cp1fe.cc1ps.com',
  },
  AWS11: {
    name: 'AWCS11',
    domain: 'https://cp2ap.cc2ps.cc',
    reportDomain: 'https://cp2fe.cc2ps.cc',
  },
  AWS12: {
    name: 'AWCS12',
    domain: 'https://spbap.in2casino.com',
    reportDomain: 'https://spbfe.in2casino.com',
  },
  AWSKR1: {
    name: 'AWSKR1',
    domain: 'https://kraap.kkrwplay.com',
    reportDomain: 'https://krafe.kkrwplay.com',
  },
}

export const GAMETYPE_LIST = ['BINGO', 'EGAME', 'ESPORTS', 'FH', 'LIVE', 'LOTTO', 'SLOT', 'SPORTS', 'TABLE', 'VIRTUAL']

export const GAMETYPE_OPTIONS = GAMETYPE_LIST.map(gameType => ({ label: gameType, value: gameType }))

export const COOLGAME_PRESERVE_MULTIPLIER = 128

export const COOLGAME_CURRENCY_ANTE = {
  AED: 2,
  BDT: 50,
  IDR: 800,
  INR: 30,
  KRW: 500,
  LKR: 100,
  MMK: 1000,
  MYR: 1,
  NPR: 50,
  PHP: 15,
  PKR: 100,
  THB: 10,
  USD: 1,
  VND: 10000,
}

export const LANGUAGE_LIST = ['en', 'cn', 'jp', 'th', 'vn', 'kr']

export const LANGUAGE_OPTIONS = LANGUAGE_LIST.map(lang => ({ label: lang, value: lang }))
